import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { AiSettingsIndex } from '@/pages/settings/AiSettingsIndex';
import { AI_SETTINGS_PERMISSIONS, aiSettingsTabSchema } from '@/pages/settings/components/ai-settings/ai-settings-tabs';

export const Route = createFileRoute('/_authenticated/_app/settings/ai-settings')({
	validateSearch: z.object({
		tab: aiSettingsTabSchema.optional().catch(undefined),
	}),
	beforeLoad: ({ context }) => requireAnyPermission({ context, anyOf: AI_SETTINGS_PERMISSIONS }),
	component: AiSettingsIndex,
});
